// TODO: Dead Feature

export class RecoEvent {
  constructor(recoContainer, platform, recommender = 'lateral') {
    this.$recoContainer = recoContainer;
    this.platform       = platform;
    this.recommender    = recommender;
  }

  setRecommender(recommender) {
    this.recommender = recommender;
  }

  prepareLabel($node) {
    var namespace  = this.recommender.toUpperCase();
    var loginLabel = ($node.attr('data-login') === 'true') ? 'login' : 'not login';
    var platform   = this.platform;
    var title      = $node.attr('data-reco-title');
    var position   = $node.attr('data-position');
    var type       = $node.attr('data-recommendation-type');
    var score      = $node.attr('data-recommendation-score');

    return `${namespace}::${platform}::${loginLabel}::${title}::${position}::${type}::${score}`;
  }

  bindClickEvent() {
    this.$recoContainer.on('click', 'a[data-reco-title]', function(event){
      var $node = $(event.currentTarget);
      var title = this.prepareLabel($node);
      this.sendClickGAEvent(title);

      var properties = this.getProperties($node);
      this.sendPlentyEvent(properties);
    }.bind(this));
  }

  sendClickGAEvent(title) {
    ga('kmkGATracker.send', 'event', this.platform, 'click', title);
  }

  sendRelatedEvent(relatedOptions = {}) {
    var title = $("meta[property='og:title']").prop("content");
    var videoId = $("meta[data-type='Video']").data("id");

    var gaTitle = "LATERAL::CENTER::"+videoId+" - "+title;

    this.sendClickGAEvent(gaTitle);

    window.AhoyEvent.send('PLAYER RELATED::CLICK', relatedOptions);
  }

  getProperties($node) {
    var uuid      = this.$recoContainer.attr('data-recommendation-uuid');
    var page_name = this.$recoContainer.attr('data-page-name');
    var recoName  = this.$recoContainer.attr('data-recommender-name') === undefined ? this.recommender :
      this.$recoContainer.attr('data-recommender-name');

    return {
      uuid:                 uuid,
      app_name:             'vidio',
      recommender:          recoName,
      login:                $node.attr('data-login'),
      platform:             this.platform,
      video_id:             $node.attr('data-id'),
      position:             $node.attr('data-position'),
      recommendation_type:  $node.attr('data-recommendation-type'),
      recommendation_score: $node.attr('data-recommendation-score'),
      page_name:            page_name
    };
  }

  sendPlentyEvent(properties) {
    window.AhoyEvent.send("RECOMMENDATION::CLICK", properties);
  }
}
